import { mcfSeoMetaData } from './mcf.seo'
import { authRepSeoMetaData } from './authorized-representative.seo'
import { claimsSeoMetaData } from './claims.seo'
import { msaSeoMetaData } from './msa.seo'
import { mspSeoMetaData } from './msp.seo'
import { eMSNSeoMetaData } from './emsn.seo'
import { fallbackSeoMetaData } from './fallback.seo'
import { accountSettingsSeoMetaData } from './account-settings.seo'
import { preventiveServicesSeoMetaData } from './preventive-services.seo'
import { accountHomeSeoMetaData } from './account-home.seo'
import { rxDrugCardSeoMetaData } from './rx-drug-card.seo'
import { premiumsSeoMetaData } from './premiums.seo'

export const seoMetaData = mcfSeoMetaData
  .concat(accountSettingsSeoMetaData)
  .concat(authRepSeoMetaData)
  .concat(claimsSeoMetaData)
  .concat(msaSeoMetaData)
  .concat(mspSeoMetaData)
  .concat(eMSNSeoMetaData)
  .concat(preventiveServicesSeoMetaData)
  .concat(accountHomeSeoMetaData)
  .concat(rxDrugCardSeoMetaData)
  .concat(premiumsSeoMetaData)
  // Fallback uses a non-exact match over the entire app. It needs concatenated last
  .concat(fallbackSeoMetaData)
